import { usePageTitle } from '@/hooks/usePageTitle';
import { Outlet } from 'react-router-dom';

const Refund = () => {
  usePageTitle('refund');

  return <Outlet />;
};

export default Refund;
